import { downloadFileFromUrl } from '@sib/files';
import { generateExportFileName } from './files';

interface ExportTableDataOptions<TQuery> {
  baseFileName: string;
  query: TQuery;
  extension?: string;
  exportTable: (params: {
    filename: string;
    query: TQuery;
  }) => Promise<Blob | File>;
}

export interface BaseTableCsvExportOptions {
  filters: string[];
  sorting: string[];
  baseFileName: string;
}

export const exportTableData = async <TQuery>({
  baseFileName,
  query,
  extension = 'csv',
  exportTable,
}: ExportTableDataOptions<TQuery>) => {
  const exportFileName = generateExportFileName(baseFileName);
  const exportFile = await exportTable({
    filename: exportFileName,
    query,
  });
  const blob = exportFile instanceof Blob ? exportFile : new Blob([exportFile]);
  const downloadUrl = URL.createObjectURL(blob);

  downloadFileFromUrl(downloadUrl, `${exportFileName}.${extension}`);
  window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
};
